export const CREDIT_REJECTION_CODE = 'CREDIT_REJECTION'; // eslint-disable-line
export const CREDIT_REJECTION_BDC_SCORING_NEGATIVE = 'BDC_SCORING_NEGATIVE';
export const CREDIT_REJECTION_EXT_SCORE_CUT = 'EXT_SCORE_CUT';
